import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogState } from '../../models/dialog-state';

@Component({
  selector: 'app-etp-fee-not-paid',
  templateUrl: './etp-fee-not-paid.component.html',
  styleUrls: ['./etp-fee-not-paid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EtpFeeNotPaidComponent {
  public set currentState(newState: DialogState) {
    this.isDialogVisible = !!newState;
    if (this.isDialogVisible) {
      this.state = newState;
      this.isTextContent = typeof newState.content === 'string';
    }
  }

  public get currentState() {
    return this.state;
  }

  public isDialogVisible = false;
  public isTextContent = true;
  public mail: string = '';
  public isShowEmailDialog: boolean = false;
  private state: DialogState;

  public onHide($event: Event) {
    if (this.state.onHide) {
      this.state.onHide($event);
    }
    this.isDialogVisible = false;
  }

  public onShow($event: Event) {
    if (this.state.onShow) {
      this.state.onShow($event);
    }
  }

  public showEmailDialog() {
    this.isShowEmailDialog = true;
  }

  public onAccept($event) {
    if (this.state.onAccept) {
      this.state.onAccept($event);
    }
    this.isDialogVisible = false;
  }
}
